import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {SingleQuestionComponent} from '../../components/surveys/single-question/single-question.component';
import {SurveyService} from '../../services/surveys.service';
import {TranslateService} from '@ngx-translate/core';
import {ToastService} from '../../services/general/toast.service';

@Component({
  selector: 'app-modal-revise-question',
  templateUrl: './modal-revise-question.component.html',
  styleUrls: ['./modal-revise-question.component.scss']
})
export class ModalReviseQuestionComponent implements OnInit {
  @ViewChild(SingleQuestionComponent) questionComponent!: SingleQuestionComponent;

  originalQuestion: any;
  newQuestion: any;

  constructor(
    public dialogRef: MatDialogRef<ModalReviseQuestionComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private surveyService: SurveyService,
    private translateService: TranslateService,
    private toast: ToastService
  ) {
    this.originalQuestion = data.question;
  }

  ngOnInit(): void {
    if (this.originalQuestion?.customs?.revision_question) {
      this.newQuestion = this.originalQuestion.customs.revision_question;
    } else {
      this.newQuestion = JSON.parse(JSON.stringify(this.originalQuestion));
    }
    this.newQuestion.id = 1; // Temporary ID
    this.newQuestion.is_new = true;
    // Clear response data if any
    this.newQuestion.response = {customs: {}, attachments: []};
  }

  save() {
    if (!this.newQuestion.question) {
      this.toast.error(
        this.translateService.instant('generic.error'),
        this.translateService.instant('modals.modal-survey-details.errors.title-is-required')
      );
      return;
    }

    this.dialogRef.close(this.newQuestion);
  }

  close() {
    this.originalQuestion.final_decision = null;
    this.dialogRef.close();
  }

  cancelDecision() {
    this.dialogRef.close({cancelled: true});
  }
}
